import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCrop } from '@modules/editor';
import { Rnd } from 'react-rnd';
import { Box } from '@mui/material';

function CropCanvas() {
    const dispatch = useDispatch();
    const el = useSelector((state: any) => state.editor.cropList);

    if (!el) return null;

    const updateElement = (updatedData: any) => {
        dispatch(updateCrop({ ...el, ...updatedData }));
    };

    const handleClick = () => {
        dispatch(updateCrop({ ...el, isEditing: true }));
    };

    return (
        <Rnd
            size={{ width: parseInt(el.width), height: parseInt(el.height) }}
            position={{ x: parseInt(el.x), y: parseInt(el.y) }}
            style={{
                border: el.isEditing ? '2px dashed #007bff' : '2px solid #007bff',
                backgroundColor: 'rgba(0, 123, 255, 0.1)',
                zIndex: el.isEditing ? 999 : 998,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#007bff',
                fontSize: '12px',
                fontWeight: 'bold'
            }}
            onDragStop={(_, d) => updateElement({ x: d.x.toString(), y: d.y.toString() })}
            onResizeStop={(_, __, ref, ___, position) => {
                updateElement({
                    width: ref.offsetWidth.toString(),
                    height: ref.offsetHeight.toString(),
                    x: position.x.toString(),
                    y: position.y.toString()
                });
            }}
            bounds="parent"
            disableDragging={!el.isEditing}
            enableResizing={el.isEditing}
            enableUserSelectHack={false}
            onClick={handleClick}
        >
            <Box className="crop-canvas__container">
                <div>{el.width} x {el.height}</div>
                {el.isEditing && <div className="crop-canvas__label">크롭 영역</div>}
            </Box>
        </Rnd>
    );
}

export default CropCanvas; 